import { Link, useParams, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { blogPosts } from '../data/blogPosts';
import { useEffect, useMemo, useState } from 'react';

export default function BlogListPage() {
  const { t } = useTranslation();
  const { lng } = useParams();
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const page = Math.max(1, parseInt(search.get('page') || '1', 10));
  // responsive page size: 4 on desktop, 3 on medium, 2 on small/mobile
  const [pageSize, setPageSize] = useState(4);
  useEffect(() => {
    const compute = () => {
      const w = window.innerWidth;
      if (w <= 640) return 2;
      if (w <= 900) return 3;
      return 4;
    };
    setPageSize(compute());
    const onResize = () => setPageSize(compute());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const total = blogPosts.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, totalPages);
  const slice = useMemo(() => {
    const start = (safePage - 1) * pageSize;
    return blogPosts.slice(start, start + pageSize);
  }, [safePage, pageSize]);
  return (
    <main>
      <Helmet>
        <title>{t('seo.blog_title')}</title>
      </Helmet>
      <header style={{ textAlign:'center', marginBottom: 16 }}>
        <h1 style={{ marginBottom: 8 }}>Blog</h1>
        <p style={{ color:'#64748b' }}>{lng==='sr' ? 'Saveti, novosti i ideje za bezbrižnu selidbu.' : 'Tips, updates and ideas for a smooth move.'}</p>
      </header>
  <div className="blog-list-grid" style={{ display: 'grid', gap: 16 }}>
        {slice.map(p => (
          <article key={p.id} style={{ border:'1px solid #e5e7eb', padding: 16, borderRadius: 12 }}>
            <img src={process.env.PUBLIC_URL + p.image} alt={lng==='sr' ? p.title_sr : p.title_en} style={{ width:'100%', height:'clamp(150px, 38vw, 220px)', objectFit:'cover' }} />
            <h3>{lng==='sr' ? p.title_sr : p.title_en}</h3>
            <p>{(lng==='sr' ? p.content_sr : p.content_en).slice(0, 80)}...</p>
            <Link to={`/${lng}/blog/${p.slug}`}>{lng==='sr' ? 'Pročitaj više' : 'Read more'}</Link>
          </article>
        ))}
  </div>
  <nav aria-label="Pagination" style={{ display:'flex', gap:8, marginTop:16, justifyContent:'center', alignItems:'center' }}>
    <Link to={`/${lng}/blog?page=${Math.max(1, safePage-1)}`} style={{ pointerEvents: safePage===1 ? 'none' : undefined, opacity: safePage===1 ? .5 : 1 }}>&laquo; Prev</Link>
    <span>Page {safePage} / {totalPages}</span>
    <Link to={`/${lng}/blog?page=${Math.min(totalPages, safePage+1)}`} style={{ pointerEvents: safePage===totalPages ? 'none' : undefined, opacity: safePage===totalPages ? .5 : 1 }}>Next &raquo;</Link>
  </nav>
  <style>{`
    .blog-list-grid{ grid-template-columns: repeat(4, 1fr); }
    @media (max-width: 900px){ .blog-list-grid{ grid-template-columns: repeat(3, 1fr); } }
    @media (max-width: 640px){ .blog-list-grid{ grid-template-columns: repeat(2, 1fr); } }
  `}</style>
    </main>
  );
}
